export const configureUrl = (url) => {
  let authUrl = url;
  if (url && url[url.length - 1] === "/") {
    authUrl = url.substring(0, url.length - 1);
  }
  return authUrl;
};
export const LIMIT = 10;
export const errorMessage = (response) => {
  try {
    return (
      response?.response?.data?.message ||
      response?.data?.response?.message ||
      response?.data?.message ||
      response?.message ||
      "Something went wrong"
    );
  } catch (e) {
    return e?.message || "Something went wrong";
  }
};
export const findObjectInArray = (arr = [], keyName, matchingKey) => {
  try {
    return arr?.find((o) => o[keyName] === matchingKey);
  } catch (e) {
    return {};
  }
};

export const formatMozambicanMetical = (amount) => {
  // Format in INR-style grouping wuith MZN currency
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MZN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};   

export const getRandomRating = () => (Math.round((Math.random() * (50 - 45) + 45) * 10) / 100).toFixed(1);
console.log(getRandomRating());

// A property with no pool value on record is treated the same as
// pool = No, so filtering by "No" also matches null/undefined pool data
// instead of only records explicitly saved as pool = false.
export const matchesPoolFilter = (property, poolFilter) => {
  if (!poolFilter) return true;
  const raw = property?.pool;
  const hasPool = raw === true || raw === 1 || raw === "1" || raw === "true";
  return poolFilter === "1" ? hasPool : !hasPool;
};

export const parseStyledText=(text)=> {
  const regex = /\[\[strong\]\](.*?)\[\[\/strong\]\]/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const { index } = match;
    if (index > lastIndex) {
      parts.push(text.substring(lastIndex, index)); // normal text
    }
    parts.push(<strong key={index}>{match[1]}</strong>); // strong text
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex)); // remaining normal text
  }

  return parts;
}